import React, { useContext } from 'react';
import { DeviationViewMode } from '@wix/da-react-context/pkg/SessionContext';
export var DeviationViewContext = React.createContext(DeviationViewMode.Normal);
DeviationViewContext.displayName = 'DeviationViewContext';
// hook for convenience...
export function useDeviationViewContext() {
    var viewMode = useContext(DeviationViewContext);
    var contextProps = {
        viewMode: viewMode,
        isTheater: viewMode === DeviationViewMode.Theater,
        isFullscreen: viewMode === DeviationViewMode.Fullscreen,
    };
    return contextProps;
}
//# sourceMappingURL=DeviationViewContext.js.map